import { render, staticRenderFns } from "./AddStudentInAlbumDialog.vue?vue&type=template&id=8e97dcb2"
import script from "./AddStudentInAlbumDialog.vue?vue&type=script&lang=js"
export * from "./AddStudentInAlbumDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e97dcb2')) {
      api.createRecord('8e97dcb2', component.options)
    } else {
      api.reload('8e97dcb2', component.options)
    }
    module.hot.accept("./AddStudentInAlbumDialog.vue?vue&type=template&id=8e97dcb2", function () {
      api.rerender('8e97dcb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/album/AddStudentInAlbumDialog.vue"
export default component.exports